import { render } from "./DemoDataBlock.vue?vue&type=template&id=e48dbb14"
import script from "./DemoDataBlock.vue?vue&type=script&lang=js"
export * from "./DemoDataBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__